import { useMemo } from 'react';
import './Loader.css';

const WORDS = ['карты', 'стеки', 'ауты', 'шансы'];

export default function Loader() {
  const shuffled = useMemo(() => {
    const start = Math.floor(Math.random() * WORDS.length);
    const ordered = [...WORDS.slice(start), ...WORDS.slice(0, start)];
    return [...ordered, ordered[0]];
  }, []);

  return (
    <div className="loader-wrap">
      <div className="loader">
        <p>считаю</p>
        <div className="words">
          {shuffled.map((w, i) => (
            <span key={i} className="word">{w}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
